import gql from 'graphql-tag'
import { orderGql, userGql } from './fragments.gql'

export const MY_ORDERS_QUERY = gql`
  query MyOrders {
    myOrders {
      id
      status
      lineItems {
        id
        product {
          id
          name
          photo
          allergens
          diets
          price
          currencyCode
          containerFee
        }
        quantity
      }
      seller {
        id
        firstName
        lastName
        avatar
        sellerRating
      }
      subTotal
      deliveryFee
      taxes
      total
      currencyCode
      createdAt
      deliverOn
      completedAt
      abandonedAt
      refundedAt
      reversedAt
      canceledAt
    }
  }
`

export const RECEIPT_QUERY = gql`
  query GetReceipt($id: ID!) {
    order(id: $id) {
      id
      status
      lineItems {
        id
        product {
          id
          name
          price
          currencyCode
          containerFee
        }
        quantity
      }
      seller {
        id
        firstName
        lastName
      }
      subTotal
      deliveryFee
      taxes
      total
      currencyCode
    }
  }
`

export const FILTER_MY_ORDERS_QUERY = gql`
  query FilterMyOrders($where: OrderWhereInput!) {
    filterOrders(where: $where) {
      ${orderGql}
      buyer {
        ${userGql}
      }
      seller {
        ${userGql}
      }
    }
  }
`

export const CREATE_ORDER_MUTATION = gql`
  mutation CreateOrder($data: OrderCreateData!) {
    createOrder(data: $data) {
      id
    }
  }
`

export const UPCOMING_ORDERS_SUBSCRIPTION = gql`
  subscription {
    upcomingOrders {
      node {
        id
        lineItems {
          id
          product {
            id
            name
          }
          quantity
        }
        deliverOn
      }
    }
  }
`
